/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Super_Admins_SubtitleInputs */



/**
* | output |
* | --- |
* | "Staff who can administer the platform. Everyone here sees every organization and every partner." |
*
* @param {Partner_Admin_Super_Admins_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_super_admins_subtitle = /** @type {((inputs?: Partner_Admin_Super_Admins_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Super_Admins_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitarbeitende, die die Plattform verwalten können. Alle hier sehen jede Organisation und jeden Partner.")
	return /** @type {LocalizedString} */ ("Staff who can administer the platform. Everyone here sees every organization and every partner.")
});